<body>
    <app-start></app-start>
    <app-about-me></app-about-me>
    <app-skill-set></app-skill-set>
    <app-my-work></app-my-work>
    <app-collegues></app-collegues>
    <app-contact></app-contact>
</body>